import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { Response } from 'src/app/services/models/response.model'
import { Payment } from './models/payment/payment.model';
import { BatchCancelRequest } from './models/payment/batch.cancel.request.model';
// import { PaymentGetRequest } from './models/payment/payment.get.request.model';

@Injectable()
export class PaymentService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl = API_URI.payment;
  }

  searchPayment(data: string): Observable<Response<Payment[]>> {
    const url = `/SearchPayment?searchData=` + encodeURIComponent(data);
    return this.get(url)
      .map(result => new Response<Payment[]>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }

  // getPaymentDetail(data: PaymentGetRequest): Observable<Response<any>> {
  //   return this.post(`/GetPaymentDetail`, data, {})
  //   .map(result => new Response<any>(result.code, result.message, result.responseData ))
  //   .catch(this.handleError);
  // }
  updatePayment(payment: any, status: Number, note: string): Observable<Response<Payment>> {
    const url = `/UpdatePayment`;
    return this.post(url, {
      Status: status,
      TransactionID: payment.transactionID,
      PaymentID: payment.paymentID,
      Note: note,
      Code: -16
    })
      .map(result => new Response<Payment>(result.code, result.message, result.responseData))
      .catch(this.handleError);
  }
}
